export default [{
  path: '/workorder',
  component: () => import('@/views/workorder'),
  children: [{
    path: 'jobplan',
    component: () => import('@/views/workorder/jobplan')
  }]
}]